import { CustomRiskLevel } from "src/core/constants/risk";
import { RiskLevel } from "src/core/gql/graphql";

/**
 * Mappe un niveau de risque en un niveau de risque personnalisé.
 * On fait ça car on ne gère pas les risques "CRITICAL" et "VERYHIGH" (et aussi
 * parce que Normal = MEDIUM).
 */
export const mapRiskLevelToCustomRiskLevel = (riskLevel?: RiskLevel): CustomRiskLevel => {
  switch (riskLevel) {
    case RiskLevel.Low:
      return CustomRiskLevel.LOW;
    case RiskLevel.Normal:
      return CustomRiskLevel.MEDIUM;
    case RiskLevel.High:
      return CustomRiskLevel.HIGH;
    default:
      return CustomRiskLevel.UNDEFINED;
  }
};

/**
 * Mappe un niveau de risque personnalisé en un niveau de risque.
 * On fait ça car on ne gère pas les risques "CRITICAL" et "VERYHIGH" (et aussi
 * parce que Normal = MEDIUM).
 */
export const mapCustomRiskLevelToRiskLevel = (customRiskLevel?: CustomRiskLevel): RiskLevel => {
  switch (customRiskLevel) {
    case CustomRiskLevel.LOW:
      return RiskLevel.Low;
    case CustomRiskLevel.MEDIUM:
      return RiskLevel.Normal;
    case CustomRiskLevel.HIGH:
      return RiskLevel.High;
    default:
      return RiskLevel.Normal;
  }
};
